import { useCallback } from 'react';
// Extensionless on purpose — see useBusinessDay.ts. Metro cannot follow a
// '.js' specifier pointing at a '.ts' file, and this is reachable from mobile.
import { useI18n } from '../i18n/index';
import { elapsedExact } from '../contracts/elapsed-words';

/**
 * Say how long something has been waiting, in the reader's own language.
 *
 * The pure function takes the locale so it can be tested and used outside
 * React; this binds the active one once, so no screen has to thread a locale
 * through every column definition — which is how a format ends up spelled out
 * by hand in one screen and differently in the next.
 *
 *   const { exactly } = useElapsed();
 *   ...
 *   render: (j) => exactly(j.waitingMinutes)
 */
export function useElapsed(): {
  readonly exactly: (minutes: number | null | undefined) => string;
} {
  const { locale } = useI18n();

  const exactly = useCallback(
    (minutes: number | null | undefined) => elapsedExact(minutes, locale),
    [locale],
  );

  return { exactly };
}
